<mat-dialog-content class="mat-typography login-mat-container">
  <div class="section_login login-sect">

    <button style="outline: none; padding-top: 2px;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass"
      [mat-dialog-close]="true" id="closeBtn">
      <img src="../../../assets/icons/x-button.svg">

    </button>

    <!-- <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7  ">
        <div class="container_login">
          <img [src]="data.userType.imgPath" height="550px" width="720" alt="Nature"
            style="width:100%; border-radius: 10px !important;">
          <div class="text-block " [id]="'textBlock_'+ data.userType.user">
            <h4 class="colgin_headerText"> {{data.userType.titleOne}}<br><span
                class="loginP_textTwo">{{data.userType.titleTwo}}</span></h4>
            <p class="login_textP">{{data.userType.text}}</p>
          </div>
        </div>
      </div> -->

    <!-- Login start -->
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-login" style="width: 89%;margin: auto;"
      *ngIf="showLogin">
      <div class="form_section">
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-center pb-4">
            <img src="../../../assets/SVG/logo.svg" class="w-161">
          </div>
          <div class="col-sm-12">
            <p class="authHeadText" style="font-family: sora !important;">Sign in to your Account </p>
          </div>

          <div class="col-sm-12">
            <form class="signIn_form" [formGroup]="loginForm">
              <mat-form-field class="example-full-width">
                <mat-label class="iconlabel"><mat-icon style=""><img src="../../../assets/SVG/mail.svg"
                      style="display: flex;" class="position-absolute"></mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                  <span style="padding-top: 2px;" *ngIf="loginForm.value.email == '';else elseBlock">Enter email</span>
                  <ng-template #elseBlock><span></span></ng-template>
                </mat-label>
                <input matInput placeholder="" autocomplete="off"
                  formControlName="email" (keypress)="checkEnterPress($event)">
              </mat-form-field>
              <!-- <div *ngIf="submitted && f['email'].errors" class="form-error">
                <div *ngIf="f['email'].errors['required']">*required</div>
                <div *ngIf="f['email'].errors['pattern']">*Enter a valid Email Address</div>
              </div> -->

              <div *ngIf="loginForm.value.email && f['email'].errors" class="form-error"
                style="transform: translate(0px, -12px);">
                <div *ngIf="f['email'].errors['pattern']">Enter a valid Email Address</div>
              </div>

              <mat-form-field class="example-full-width">
                <mat-label class="iconlabel"><mat-icon><img src="../../../assets/authImg/lock.svg"
                      style="display: flex;" class="position-absolute"></mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
                  <span *ngIf="!loginForm.value.password">Enter password</span>
                </mat-label>

                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" readonly
                  onfocus="this.removeAttribute('readonly')" autocomplete="off" (keypress)="checkEnterPress($event)">
                <button mat-icon-button class="eye-icon" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide">
                  <mat-icon><img src="../../../assets/authImg/eye-closed.svg"
                      style="display: flex; width: 20px;" class="position-absolute"></mat-icon>
                </button>
              </mat-form-field>
              <!-- <div *ngIf="submitted && f['password'].errors" class="form-error">
                <div *ngIf="f['password'].errors['required']">*Password required</div>
                <div *ngIf="f['password'].errors['minLength']">*Password must have at least 8 characters.</div>
                <div *ngIf="f['password'].errors['pattern']">*Please choose a stronger password. It should contain at least 8 Characters, 1 Lowercase letter, 1 Uppercase letter, 1 Special character and 1 Number.</div>
              </div> -->
              <div *ngIf="loginForm.value.password && removeSpacePhone(loginForm.value.password)<8" class="form-error"
                style="transform: translate(0px, -12px);">
                Length must be greater than 8 characters
              </div>


              <!-- <div *ngIf="oneUpperCase" class="form-error">1 Uppercase letter required</div>
              <div *ngIf="oneNumber" class="form-error">1 Number required</div>
              <div *ngIf="oneLowerCase" class="form-error">1 Lowercase letter required</div>
              <div *ngIf="OnespecialChar" class="form-error">1 Special letter required</div> -->
              <p class="forgetPass" (click)="forgetPassClick()" [mat-dialog-close]="true">Forgot Password?</p>

              <button mat-raised-button color="warn" class="authSignIn" [disabled]="loginForm.invalid"
                (click)="onClickLogin()">Sign In</button>
            </form>
            <!-- <p class="SignupAsk" style="font-family: sora !important; font-size: 16px;"> Don’t have an account? <span
                class="signupFNCSS" (click)="AuthOpen('signup')" style="cursor: pointer;">Sign Up</span></p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Login end -->
  </div>
  <!-- </div> -->

</mat-dialog-content>
